export type LibraryWorkoutLike = {
  id: string;
  name: string;
  focusTags?: string[];
  equipmentTags?: string[];
  estimatedDurationMinutes?: number;
  exerciseCount?: number;
  difficulty?: string;
};

export function filterLibraryWorkouts<T extends LibraryWorkoutLike>(
  workouts: T[],
  search: string,
  focusTag: string | null,
): T[] {
  const q = search.trim().toLowerCase();
  return workouts.filter((w) => {
    if (focusTag) {
      const tags = w.focusTags ?? [];
      if (!tags.some((t) => t.toLowerCase() === focusTag.toLowerCase())) return false;
    }
    if (!q) return true;
    const hay = [w.name, ...(w.focusTags ?? []), ...(w.equipmentTags ?? [])]
      .join(' ')
      .toLowerCase();
    return hay.includes(q);
  });
}

/** Top focus tags by frequency across the library (stable alpha for ties). */
export function topFocusTagChips(workouts: LibraryWorkoutLike[], limit = 5): string[] {
  const counts = new Map<string, number>();
  workouts.forEach((w) => {
    (w.focusTags ?? []).forEach((tag) => {
      const key = tag.trim();
      if (!key) return;
      counts.set(key, (counts.get(key) ?? 0) + 1);
    });
  });
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, limit)
    .map(([tag]) => tag);
}
